/**
 * Configuration for dashboard colors
 * Paleta con 3 colores específicos: #293241, #ee6c4d, #98c1d9
 */
export class DashboardColorsConfig {
  // Color 1: Azul oscuro/gris - #293241
  static readonly blue = '#03045e';
  
  // Color 2: Coral/Rojo salmón - #ee6c4d
  static readonly coral = '#0077b6';
  
  // Color 3: Azul claro/Cyan - #98c1d9
  static readonly cyan = '#00b4d8';

  // Paleta principal de 3 colores para charts
  static readonly chartColors = {
    blue: DashboardColorsConfig.blue,
    coral: DashboardColorsConfig.coral,
    cyan: DashboardColorsConfig.cyan,
  };

  // Paleta para distribución por población
  static readonly population = {
    general: DashboardColorsConfig.blue,   // #293241
    vih: DashboardColorsConfig.coral,      // #ee6c4d
  };

  // Paleta para resultados histológicos (usa los 3 colores)
  static readonly histological = {
    negative: DashboardColorsConfig.cyan,      // #98c1d9 (azul claro para negativos)
    nic2_3: DashboardColorsConfig.coral,       // #ee6c4d (coral)
    adenocarcinomaInSitu: DashboardColorsConfig.blue, // #293241 (azul oscuro)
  };

  // Paleta para resultados NAAT VPH
  static readonly naatVph = {
    positive: DashboardColorsConfig.coral,     // #ee6c4d (coral para positivas)
    negative: DashboardColorsConfig.blue,      // #293241 (azul oscuro para negativas)
  };

  // Paleta para seguimiento por triajes
  static readonly triage = {
    positive: DashboardColorsConfig.coral,     // #ee6c4d (coral)
    negative: DashboardColorsConfig.cyan,      // #98c1d9 (azul claro)
    inProgress: DashboardColorsConfig.blue,     // #293241 (azul oscuro)
  };
}

